"use strict";

module.exports = function ($stateProvider) {
  $stateProvider.state("dashboard.departments.department.tasks", {
    url: "/tasks?date&startDate&endDate",
    templateUrl: "dashboard-tasks/dashboard-tasks.html",
    controller: "dashboardTasksCtrl as ctrl",
    resolve: {
      tasks: [
        "$stateParams",
        "Department",
        "Member",
        function ($stateParams, Department,Member) {
          var startDate;
          var endDate;
          if ($stateParams.startDate) {
            startDate = new Date($stateParams.startDate);
            endDate = new Date($stateParams.endDate);
          } else {
            //startDate = new Date();
            return [];
          }

          if (startDate.toString() === "Invalid Date") {
            startDate = new Date();
            $stateParams.date = startDate;
            console.log("Error startDate");
            return [];
          }

          return Department.teams({
            id: $stateParams.departmentId,
            filter: {
                "include": {
                    "relation": "members",
                    "scope": {
                        "fields": ["id","email"]
                    }
                }
            },
          }).$promise.then(function (members) {
            let lstMembersId = members.flatMap(team=>team.members.reduce((lst,member)=>{lst.push(member.id);return lst},[])) 
            return Member.find({
                "filter":{
                    "where": {
                        "id": {
                            "inq": lstMembersId
                        }
                    },
                    "include": [
                        {
                            "relation": "items",
                            "scope": {
                                "fields": [
                                    "_createdAt",
                                    "_startedAt","closedAt",
                                    "id",
                                    "taskId",
                                    "deptId"
                                ],                                
                                "where": {
                                    "deptId": $stateParams.departmentId,
                                    "taskId": {
                                        "ne": null
                                    },
                                    "_startedAt": {
                                        "between": [startDate, endDate]
                                    }
                                }
                            }
                        },
                        {
                            "relation": "task",
                            "scope": {
                                "include": [
                                    {
                                        "relation": "department"
                                    },
                                    {
                                        "relation": "client"
                                    }

                                ],
                                "where": {
                                    "or": [
                                        {
                                            "startDate": {
                                                "between": [startDate, endDate]
                                            }
                                        },
                                        {
                                            "and": [
                                                {
                                                    "repeat": true
                                                }
                                            ]
                                        }
                                    ]
                                }
                            }
                        }
                    ]
                }
            }).$promise
            .then(function(membersWithTasks) {
                return membersWithTasks;
            });
          });
         
        },
      ],
    },
    data: {
      authorizedRoles: ["admin", "owner", "supervisor", "fieldAdmin"],
    },
  });
};
